/**
 * digestApi.ts — ダイジェストログ API クライアント（2026-07-26）
 *
 * sys/digest/api.php への薄いラッパー。DigestWindow（表示）と
 * pusherService（全イベント raw 収集）で共用する。
 *
 * 仕様書: md/master_md/feature-digest-window.md
 */
import { getInstance, LINE_SYNC_KEY } from '../config/instances';
import { isTrainingMode } from '../training/trainingMode';

export const DIGEST_API_URL = (process.env.REACT_APP_DIGEST_API_URL as string)
    || 'https://booking.trailernchu.co.jp/sys/digest/api.php';

export interface DigestLogEntry {
    id?: number;          // DB 採番（ローカル即時表示時は undefined）
    event_key: string;
    log_time: string;     // 'YYYY-MM-DD HH:MM:SS'
    type: string;         // 'message' | 'transfer' | 'vehicle' | 'raw'
    text: string;
    meta?: any;
}

export const callDigestApi = async (action: string, body: any): Promise<any> => {
    const res = await fetch(`${DIGEST_API_URL}?action=${action}&api_key=${LINE_SYNC_KEY}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body),
    });
    return res.json();
};

/** ログを1件保存（fire-and-forget）。event_key 重複は DB 側で無視される */
export const appendDigestLog = (entry: DigestLogEntry): void => {
    // トレーニングモード中は本番のダイジェストログを汚さない（2026-08-24）
    if (isTrainingMode()) return;
    callDigestApi('append', { ...entry, instance: getInstance() }).catch(() => { /* オフライン等は無視 */ });
};
